var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(-1586 -288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M1600.5,308h-13a1.5,1.5,0,0,1-1.5-1.5v-17a1.5,1.5,0,0,1,1.5-1.5h13a1.5,1.5,0,0,1,1.5,1.5v17A1.5,1.5,0,0,1,1600.5,308Zm-13-19a.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-17a.5.5,0,0,0-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M1604.5,312h-13a1.5,1.5,0,0,1-1.5-1.5v-1a.5.5,0,0,1,1,0v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-17a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1,0-1h1a1.5,1.5,0,0,1,1.5,1.5v17A1.5,1.5,0,0,1,1604.5,312Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.cfa54590c6c1da830e30acc16361bf9d.svg";
export { ForwardRef as ReactComponent };